export class AuctionAdminDefaults {
    public defaultBidIncrement!:number;
    public defaultMakeOfferStartPricePercent!:number;
    public defaultMakeOfferBuyNowPricePercent!:number;
    public defaultMakeOfferTimeOutMinutes!:number;
    public defaultBuyerPremiumPercent!:number;
}